var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AreaTemplate',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"message":_vm.message,"url":"https://imasugu-kanteishi.com/","image":"img/logo_kanteishi.png","comment":_vm.comment,"button_label":"イマスグ不動産鑑定士の<br>サービスサイトへ"}})}
var staticRenderFns = []

export { render, staticRenderFns }